import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col, Text } from 'shared/components'

import * as styles from './styles'

const ControlsComponent = ({ value: event, onOpenBinaryBetModalProxy }) => (
  <Grid>
    <Row center="xs">
      <Col xs={12}>
        <Button
          circle
          small
          outlined
          disabled={event.resolved}
          onClick={onOpenBinaryBetModalProxy}
        >
          <FontAwesomeIcon
            size="lg"
            icon="balance-scale-left"
            css={styles.icon}
          />
          <Text size={11}>Resolve Binary Bet</Text>
        </Button>
      </Col>
    </Row>
  </Grid>
)

ControlsComponent.propTypes = {
  value: PropTypes.shape(),
  onResetBetResultProxy: PropTypes.func,
  onOpenBinaryBetModalProxy: PropTypes.func.isRequired,
}

export default ControlsComponent
